import dynamic from 'next/dynamic'

import type { Navbar, RouteWithPage } from '@/cms/pages'
import { PageMetaDescription } from '@/components/PageMetaDescription'
import QrCodeOverlay from '@/components/QrCodeOverlay'
import { SectionsRenderer } from '@/components/renderers/Sections'
import Header from '@/components/sections/Header'
import type { AlternateLink } from '@/hooks/useAlternateLinks'

import { PageHead } from './PageHead'

const Footer = dynamic(async () => import('@/components/sections/Footer').then((mod) => mod.Footer))

export const Page = (props: {
  route: RouteWithPage
  navbar?: Navbar
  alternateLinks: AlternateLink[]
}) => {
  return (
    <>
      <QrCodeOverlay />
      <PageHead alternateLinks={props.alternateLinks} disallowRobots={props.route.disallowRobots} />

      <PageMetaDescription metaDescription={props.route.page.metaDescription} />
      {props.route.pageType?._type !== 'website.pageType.noHeaderNoFooter' ? (
        <Header
          pageType="regular"
          navbar={props.navbar}
          routePageType={props.route.pageType}
          alternateLinks={props.alternateLinks}
        />
      ) : null}
      <SectionsRenderer sections={props.route.page.sections ?? []} />
      {props.route.pageType?._type !== 'website.pageType.noHeaderNoFooter' ? (
        <Footer
          footerColor={props.route.page.footerColor ?? undefined}
          pageType={props.route.pageType}
        />
      ) : null}
    </>
  )
}
